module.exports = __webpack_public_path__ + "static/media/LevelupLogo.063c7360.png";